import { Pipe, PipeTransform } from '@angular/core';

type DataKeyType = 'adults' | 'children' | 'rooms';

@Pipe({
  name: 'travellersTransformer',
  standalone: true,
})
export class TravellersTransformerPipe implements PipeTransform {
  transform(data: { adults: number; ages: number[]; children: number }): string {
    let results: string = '';

    const totalAdults = this.getTotalByProperty(data, 'adults');
    if(totalAdults) {
      results += `Adults: ${totalAdults}`;
    }

    const totalChildren = this.getTotalByProperty(data, 'children');
    if(totalChildren) {
      results += ` + ${totalChildren}`
    }

    return results;
  }

  public getTotalByProperty(data, key: DataKeyType): number {
    return data[key]
  }
}
